import PropTypes from 'prop-types';

export const DEFAULT_LOGS_PAGE_SIZE = 50;

export const DataWithPaginationPropType = PropTypes.shape({
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.object),
  total: PropTypes.number,
  page: PropTypes.number,
  size: PropTypes.number,
});

export const defaultDataWithPagination = {
  items: [],
  total: 0,
  page: 0,
  size: 0,
};
